import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { trafficSource } from '@shared/utils-universal/traffic-source';

const useTrafficSource = () => {
  const location = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const source = searchParams.get('source');
    return trafficSource({ source });
  }, [location.search]);
};

export default useTrafficSource;
